// extracted by mini-css-extract-plugin
export default {"row":"contactRow_row__XNY+M","contactRow_main":"contactRow_contactRow_main__0B25d","title":"contactRow_title__ODX67"};